import {
  AppInsightsContext,
  MetadataContext,
  ModuleBase,
  ReportsGrid,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
  UserContext,
} from '@/components';
import {
  CognitiveFilterRequestModel,
  ModuleBaseModel,
  ModuleBasePropsModel,
  ReportSearchModel,
  UiConfigurationModel,
  ReportCardType,
} from '@/types';
import { useTranslations } from 'next-intl';
import { useContext, useEffect, useState } from 'react';
import tailwindConfig from '@/tailwind.screens';
import { useRouter } from 'next/router';

type RelatedItemsModel = ModuleBaseModel<
  {
    heading: string;
    headingTag: string;
    description: string;
    anchor: string;
    uiConfiguration?: UiConfigurationModel;
    requestFilter?: CognitiveFilterRequestModel;
    cards: ReportSearchModel[];
    cardType: ReportCardType;
  } & ModuleBasePropsModel
>;

const EditorsPickModule = (data: RelatedItemsModel) => {
  const { props } = data;
  const t = useTranslations();

  const appInsights = useContext(AppInsightsContext);
  const user = useContext(UserContext);
  const { pageId } = useContext(MetadataContext);
  const router = useRouter();

  const [gridLayout, setGridLayout] = useState<'listingGrid' | 'singleRowDrag'>('listingGrid');

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= parseInt(tailwindConfig.screens.xl, 10)) {
        setGridLayout('listingGrid');
      } else {
        setGridLayout('singleRowDrag');
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const onCardClick = (e: React.MouseEvent, data: ReportSearchModel) => {
    appInsights.trackCustomEvent(TrackEventName.REPORT, TrackEventKey.EDITORS_PICK, TrackEventType.SELECTED, user, {
      pageId,
      pagePath: router.asPath,
      reportID: data.reportId,
    });
  };

  return (
    <ModuleBase
      data={{ ...data, props: { ...props, noPaddingOnTop: true, anchor: props.anchor || 'report-editors-pick' } }}
      className="overflow-hidden print:hidden"
    >
      <div className="mx-auto [&_.heading]:text-lg [&_.heading]:font-bold">
        <ReportsGrid
          uiConfiguration={{
            hideArrows: true,
            hideViewMore: true,
            pageSize: 3,
            layout: gridLayout,
            limit: 1,
            ...props.uiConfiguration,
          }}
          cards={props.cards}
          cardType={props.cardType}
          requestFilter={props.requestFilter}
          heading={{
            heading: t('editorsPick.$editorsPickHeading'),
            description: t('editorsPick.$editorsPickText'),
          }}
          onCardClick={onCardClick}
        />
      </div>
    </ModuleBase>
  );
};

export default EditorsPickModule;
